export function isValidDate(date): boolean {
    return date instanceof Date && !isNaN(<number>(<any>date));
}
